import DraftJS from 'draft-js'
import { AiUser } from './AiUser'
import { Attachment, BaseModel } from './common'

export enum ActivityItemType {
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
  FILE = 'file',
  TEXT = 'text'
}

interface IActivityItem extends BaseModel {
  type: ActivityItemType
  description: DraftJS.RawDraftContentState
  aiUserId: number
  aiUser: AiUser
  voiceModelId: number
  likeCount: number
  commentCount: number
  likedByUser: boolean | null
  discussionId: number
}

export interface YoutubeActivityItem extends IActivityItem {
  type: ActivityItemType.YOUTUBE
  link: string
}

export interface TiktokActivityItem extends IActivityItem {
  type: ActivityItemType.TIKTOK
  link: string
  embed: string
}

export interface FileActivityItem extends IActivityItem {
  type: ActivityItemType.FILE
  file: Attachment
}

export interface TextActivityItem extends IActivityItem {
  type: ActivityItemType.TEXT
}

export type ActivityItem =
  | YoutubeActivityItem
  | TiktokActivityItem
  | FileActivityItem
  | TextActivityItem

export const isYoutubeActivityItem = (item: IActivityItem): item is YoutubeActivityItem => {
  return item.type === ActivityItemType.YOUTUBE
}

export const isTiktokActivityItem = (item: IActivityItem): item is TiktokActivityItem => {
  return item.type === ActivityItemType.TIKTOK
}

export const isFileActivityItem = (item: IActivityItem): item is FileActivityItem => {
  return item.type === ActivityItemType.FILE
}

export const isTextActivityItem = (item: IActivityItem): item is TextActivityItem => {
  return item.type === ActivityItemType.TEXT
}
